let UsedTeams = {
    MLB_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM: 2,
    NHL_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM: 2,
};

export default UsedTeams;
